import NamaCommon from "@/utils/common/NamaCommon.ts";
import {Dialog} from "quasar";
import ShowFieldInfoDialog from "@/components/dialogs/ShowFieldInfoDialog.vue";
import {type Component} from "vue";
import ObjectChecker from "@/utils/common/ObjectChecker.ts";
import DMProperty = namaTypes.DMProperty;
import DMEntity = namaTypes.DMEntity;

export default class FieldInfoUtils {
  static isDialogActive: boolean = false
  el: HTMLElement | null = null;
  entityType: string | undefined;

  inputFieldId(): string | undefined {

    if (!(this.el instanceof HTMLInputElement))
      return;
    const closestInputField = this.el.closest("[data-field-id]") as HTMLDivElement
    if (!closestInputField)
      return;
    return closestInputField.dataset.fieldId
  }

  booleanFieldId(): string | undefined {

    const closestInputField = (this.el?.closest("div[data-field-id]") as HTMLDivElement)
    if (!closestInputField)
      return;
    return closestInputField.dataset.fieldId
  }

  fieldEnumType() {
    const enumTypeField = this.el?.closest("input[data-enum-type-name][role=combobox]") as HTMLInputElement
    if (!enumTypeField)
      return;
    const enumTypeName = enumTypeField.dataset.enumTypeName
    const allowedValues = enumTypeField.dataset.limitedAllowedValues
    return {enumTypeName, allowedValues}
  }

  async showFieldInfo(fieldId: string, agEntityType?: string, agEnumType?: Record<string, any>) {
    if (agEntityType)
      this.entityType = agEntityType
    const entityFieldsUrl = "https://www.namasoft.com/dm/dm/" + this.entityType + ".js"
    let data = await NamaCommon.namaFetch(entityFieldsUrl, {method: "GET"});
    if (!NamaCommon.isSuccess(data))
      return;
    const entity: DMEntity = data[0];
    let parent: DMEntity = entity;
    let property: DMProperty | undefined;
    property = this.findProperty(fieldId, entity.properties)
    if (property)
      return this.showDialog(parent, property, agEnumType);
    if (entity && entity.details) {
      for (let i = 0; i < entity.details.length; i++) {
        const detail = entity.details[i];
        if (fieldId && fieldId.startsWith(detail.fullName + ".")) {
          property = this.findProperty(fieldId, detail.properties)
          if (ObjectChecker.isEmptyOrNull(property))
            continue;
          parent = detail;
          break;
        }
      }
      if (property)
        return this.showDialog(parent, property, agEnumType)
    }
  }

  findProperty(fieldId: string, properties?: DMProperty[]): DMProperty | undefined {
    if (!fieldId || !properties)
      return undefined;
    for (let i = 0; i < properties.length; i++) {
      const property = properties[i];
      if (property.fullName == fieldId) {
        return property
      }
    }
  }

  showDialog(parent: DMEntity, property: DMProperty, agEnumType?: Record<string, any>) {
    Dialog.create({
      component: ShowFieldInfoDialog,
      componentProps: {
        property,
        entityType: this.entityType,
        parent,
        enumType: agEnumType ?? this.fieldEnumType(),
      }
    }).onDismiss(() => {
      FieldInfoUtils.isDialogActive = false
    });
  }

  static UpdateTranslationsDialogIndirectComponent: Component;
  static async showFieldInfoHandler(e: MouseEvent) {
    if (this.isDialogActive)
      return;
    if (!e)
      return;
    await new FieldInfoUtils()._showInfo(e);
  }

  async _showInfo(e: MouseEvent) {
    this.el = e.target as HTMLElement
    this.entityType = (this.el.closest("div[data-entity-type]") as HTMLDivElement | undefined)?.dataset.entityType
    if (!this.entityType)
      return;
    const fieldId = this.inputFieldId() || this.booleanFieldId()
    if (!fieldId)
      return;
    e.preventDefault();
    FieldInfoUtils.isDialogActive = true;
    return await this.showFieldInfo(fieldId)
  }
}
